<template lang="pug">
  .d-case
    img.top-img(src="~assets/case/05/img1.png")
    .content
      .case-num Vol.05
      .case-title 上海93㎡萌趣三口之家，每天都像生活在游乐场
      .line1 懂窝客户Sarah家有一个3岁的萌娃，为了给孩子创造一个充满童趣的空间，特地请了设计师夏天来做改造，把家变成“游乐场”。
      .cont-title 关于屋主
      .line1 Sarah，辣妈&手账达人。她与先生都是动漫迷，喜欢日式元素，手工咖啡重度爱好者。家有3岁萌娃。
      .cont-title 关于设计师
      .line1
        <span>独立设计师夏天，《天天向上》特邀嘉宾，擅长色彩搭配及充满童趣的设计。</span>
      .cont-title 房子的基本信息
      .line1
        <span>坐标：上海闵行</span>
        <span>面积：93㎡</span>
        <span>户型：两室一厅</span>
      img.cont-img(src="~assets/case/05/img2.png")
      .cont-title 玄关：手工达人的创作空间
      .line1 进门是一个简单的玄关。
      .line1 辣妈Sarah是一个手工达人，嫌家里的防盗门有些旧了，就贴上毛毡“修缮一番”，好看又隔音。
      .line1 左手边原先是一个转角，做成玄关柜，收纳进出门的杂物。
      img.cont-img(src="~assets/case/05/img3.png")
      .cont-title 客餐厅：给生活更多玩乐空间
      .line1 客餐厅连通成为一个大区域，厨房、小吧台、沙发区、餐厅区（观影区、收纳区）、地台儿童玩乐区一字排开。
      img.cont-img(src="~assets/case/05/img1.png")
      .cont-title 地台，孩子的专属领地
      .line1 为了让孩子有独立的玩乐空间，阳台做成高出地面的10㎡地台。
      .line1 在这里，小朋友可以爬到柜子里找玩具，坐在懂窝Q萌的布墩上看风景，在小书桌边看绘本……地暖给这个冬天更多玩乐的理由。
      .line1 地台上，特意留了3个小孔，用来放土种树，和孩子一同成长。
      img.cont-img(src="~assets/case/05/img5.png")
      .cont-title 餐厅，也是休闲娱乐区
      .line1 打破原先的客厅区，将其变成餐厅区，带来更多活动空间。
      .line1 懂窝岩板桌，简洁设计，木元素餐椅，加入一点暖色。
      .line1 电视墙做成白色收纳柜，进入卧室的门也是白色，与橱柜连为整体，关上就像一整面墙。
      .line1 这里同时也是观影区，平时把投影幕布隐藏起来。闲暇时刻，一家人围桌而坐，或者坐在地台上观影。
      img.cont-img(src="~assets/case/05/img6.png")
      .cont-title 沙发休闲区与岛台区
      .line1 Sarah的家弱化了沙发区的功能，只放了一张两人座沙发。
      .line1 夫妻俩都是咖啡重度爱好者，一个功能齐备的吧台区，满足随手冲咖啡的需求。
      .line1 小豆丁形状的玻璃墙，能和在次卧玩耍的小朋友互动。
      .line1 另一面墙做成了洞洞板兼黑板墙，展示夫妻俩的收藏，还满足了孩子的涂涂画画。
      img.cont-img(src="~assets/case/05/img7.png")
      .cont-title 主卧：宁静的“蓝色海洋”
      .line1 公共区域与私密性相对强的卧室、卫浴区，以白色的对门区隔。
      .line1 主卧，蓝色的气质，让睡眠空间更宁静。
      .line1 还做了一个步入式衣帽间，以丝绒布帘隔开。
      .line1 床边放置了一个黄铜小边几代替床头柜，用来随手放手机、杯子。
      img.cont-img(src="~assets/case/05/img8.png")
      .cont-title 次卧：用撞色勾勒出活力
      .line1 墙面做了色块处理，脏粉与灰的撞色，让空间多了很多活力。
      .line1 懂窝的沙发墩，灰色的布面与墙面呼应，Q萌外形很契合空间的气质。
      .line1 木床与灰色背景墙搭配，并不突兀。
      .line1 飘窗堆了几个懂窝的抱枕，闲时可随时倚靠。
      img.cont-img(src="~assets/case/05/img9.png")
      .cont-title 卫生间：干湿分离，好看实用
      .line1 卫生间干湿分离设计。
      .line1 淋浴区用黑色杆子隔开，贴上小花砖，用黑色梯子做收纳，风格很网红。
      .line1 干区黑色镜面浴室柜，用来收纳化妆品及洗漱用品，样式很高级。
      .line1 底部用灯带勾勒，收纳洗脸盆等，方便实用。
      .line1 洗衣机烘干机，刚好安置一旁。
      .cont-title 这样一个家，有趣，有爱，其乐融融，是最温馨最日常的生活状态。
      img.cont-img(src="~assets/case/05/img10.png")
      .cont-title1  Q&A
      .line2 <span>Q：为什么选择购买懂窝家具？</span>一开始是被懂窝家具的颜值所吸引，设计简约很有时尚感。后面仔细研究过产品，品质也非常好，一些设计细节（比如边角的处理）对小朋友也非常友好。
      .line2 <span>Q：希望给孩子打造一个怎样的家？</span>家是一个最让人放松的地方。我希望他能在这里开心的玩，快乐的长大。充满正能量，不仅有趣，还很有爱。
    img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")
</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  },
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-case
  width: 100%
  position: relative
  padding-top: 0.1px
  .top-img
    width: 100%
    position: absolute
    z-index: -1
  .content
    margin: r(869) auto 0
    width: r(1020)
    // height: r(300)
    background: #ffffff
    padding-top: 0.1px
    padding-bottom: r(350)
    .case-num
      margin: r(43) auto
      width: r(844)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #717273
      letter-spacing: 0
    .case-title
      margin: r(18) auto r(50)
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #070809
      line-height: r(60)
    .line1
      margin: r(30) auto
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #585858
      line-height: r(34)
      span
        display: block
        text-align: center
    .cont-img
      margin-top: r(60)
      width: 100%
    .cont-title
      margin-top: r(64)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
      font-weight: bolder
    .cont-title1
      margin-top: r(100)
      font-family: PingFangSC-Medium
      font-weight: bolder
      font-size: r(20)
      color: #070809
      text-align: center
    .line2
      margin: r(31) auto 0
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      line-height: r(34)
      span
        display: block
        color: #000000
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// case5.vue?5e87e86e